import React, { useEffect, useState } from "react";
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import './LoginPage.css'; // Custom CSS for additional styling

function Frontend() {
    const navigate = useNavigate();
    const [bal, setBal] = useState("");
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [activeMenu, setActiveMenu] = useState('dashboard');

    const navTo = (path) => {
        navigate(path);
        setActiveMenu(path.replace('/', ''));
        setSidebarOpen(false);
    }

    const logout = () => {
        localStorage.clear();
        navigate("/login");
    }

    useEffect(() => {        
        const fetchData = async () => {
            const userid = localStorage.getItem('userid');
            try {
                const res = await axios.get(`https://gtfundcrop.com/Rest5/wallet_api/${userid}`);
                setBal(res.data.wallet);
            } catch (error) {
                console.error("Error fetching wallet balance:", error);
            }
        };

        fetchData();
    }, []);

    return (
        <div className="app-container">
            <Helmet>
                <title>MCX Trading App</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            </Helmet>

            {/* App Header */}
            <header className="app-header">
                <div className="header-left">
                    <button 
                        className="menu-button"
                        onClick={() => setSidebarOpen(true)}
                    >
                        <i className="fa fa-bars"></i>
                    </button>
                </div>
                <div className="header-title">
<Link to="/dashboard" className="text-white">GtFuncCrop</Link>
                </div>
                <div className="header-right">
                    <Link to="/settings" className="profile-button">
                         <img src={"https://ui-avatars.com/api/?rounded=true&name="+localStorage.getItem('name')+"&size=40"} alt="User Icon" />

                    </Link>
                </div>
            </header>

            {/* Main Content */}
            <main className="app-content">
                <Outlet />
            </main>

            {/* Sidebar */}
            <div className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}></div>
            <aside className={`app-sidebar ${sidebarOpen ? 'active' : ''}`}>
                <div className="sidebar-header">
                    <div className="profile-info">
 <img src={"https://ui-avatars.com/api/?rounded=true&name="+localStorage.getItem('name')+"&size=40"} alt="User Icon" />
&nbsp;
                        <div className="profile-details">
                            <strong>{localStorage.getItem('name')}</strong>
                            <span>Client ID #000{localStorage.getItem('userid')}</span>
                        </div>
                    </div>
                    <button 
                        className="close-sidebar"
                        onClick={() => setSidebarOpen(false)}
                    >
                        <i className="fa fa-times"></i>
                    </button>
                </div>

                <div className="sidebar-balance">
                    <div className="balance-title">Balance</div>
                    <div className="balance-amount">₹{bal}</div>
                </div>

                <nav className="sidebar-menu">
                    <ul>
                       
                        <li>
                            <button onClick={() => navTo('/bank')} className="menu-item">
                                <div className="menu-icon">
                                    <i className="fa fa-building"></i>
                                </div>
                                <span>Bank Details</span>
                            </button>
                        </li>
                        <li>
                            <button onClick={() => navTo('/company')} className="menu-item">
                                <div className="menu-icon">
                                    <i className="fa fa-info-circle"></i>
                                </div>
                                <span>About Company</span>
                            </button>
                        </li>
                        <li>
                            <button onClick={() => navTo('/contact')} className="menu-item">
                                <div className="menu-icon">
                                    <i className="fa fa-comment"></i>
                                </div>
                                <span>Contact us</span>
                            </button>
                        </li>
                        <li>
                            <button onClick={logout} className="menu-item">
                                <div className="menu-icon">
                                    <i className="fa fa-sign-out-alt"></i>
                                </div>
                                <span>Log out</span>
                            </button>
                        </li>
                    </ul>
                </nav>
            </aside>

            {/* Bottom Navigation */}
            <nav className="bottom-nav">
                <Link 
                    to="/dashboard" 
                    className={`nav-item ${activeMenu === 'dashboard' ? 'active' : ''}`}
                    onClick={() => setActiveMenu('dashboard')}
                >
                    <i className="fa fa-home"></i>
                    <span>Watchlist</span>
                </Link>
                <Link 
                    to="/orders" 
                    className={`nav-item ${activeMenu === 'orders' ? 'active' : ''}`}
                    onClick={() => setActiveMenu('orders')}
                >
                    <i className="fa fa-list"></i>
                    <span>My Orders</span>
                </Link>
                <Link 
                    to="/tradebook" 
                    className={`nav-item ${activeMenu === 'tradebook' ? 'active' : ''}`}
                    onClick={() => setActiveMenu('tradebook')}
                >
                    <i className="fa fa-book"></i>
                    <span>Tradebook</span>
                </Link>
                {/* <Link 
                    to="/funds" 
                    className={`nav-item ${activeMenu === 'funds' ? 'active' : ''}`}
                    onClick={() => setActiveMenu('funds')}
                >
                    <i className="fa fa-rupee-sign"></i>
                    <span>Funds</span>
                </Link> */}
                <Link 
                    to="/settings" 
                    className={`nav-item ${activeMenu === 'settings' ? 'active' : ''}`}
                    onClick={() => setActiveMenu('settings')}
                >
                    <i className="fa fa-cog"></i>
                    <span>Settings</span>
                </Link>
            </nav>
        </div>
    );
}

export default Frontend;